import React from 'react';
import PropTypes from 'prop-types';
import './NumberFieldInput.scss';

function NumberFieldInput({
  name,
  id,
  placeholder,
  value,
  onAnswerChange,
  displayNumberFieldInput,
  label,
}) {
  return (
    <div className={`${displayNumberFieldInput ? 'display-input' : 'no-display-input'}`}>
      <label htmlFor={label}>{label}</label>
      <input
        className="form-control"
        type="number"
        name={name}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onAnswerChange(parseInt(e.target.value, 10))}
      />
    </div>
  );
}

NumberFieldInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.number,
  displayNumberFieldInput: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

NumberFieldInput.defaultProps = {
  placeholder: '',
  value: 0,
  label: '',
};

export default NumberFieldInput;
